






import { Component, Prop, Vue } from 'vue-property-decorator'
const BLOCK_SELECTOR = 'base-title'

@Component
export default class BaseTitle extends Vue {
    @Prop({
        type: Number,
        default: 1,
        validator(v) {
            return v <= 6 && v >= 1
        },
    })
    level!: number
    @Prop({ type: String, default: null }) tag!: string
    @Prop({ type: Boolean }) alt!: boolean
    @Prop({ type: Boolean }) important!: boolean

    get tagAttr() {
        return this.tag || `h${this.level}`
    }

    get classList() {
        return [
            BLOCK_SELECTOR,
            `${BLOCK_SELECTOR}--level-${this.level}`,
            {
                [`${BLOCK_SELECTOR}--alt`]: this.alt,
                [`${BLOCK_SELECTOR}--important`]: this.important,
            },
        ]
    }
}
